export class FiltrosRepMarketing{
   
    Usuario : string ='';
    Estado: string = '';
    Tipo: string = 'empresa_cliente';
    idEmpresa_Factor: string = '7';
 
 }